import React, { useEffect } from "react";
import Loader from "@client.components/Loader";
import { useAuth } from "@client.hooks/useAuth";
import ServiceProvider from "@client.services/provider";

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    ServiceProvider.Auth.logout();
  }, [logout]);

  return <Loader loading={true} />;
};

export default Logout;
